import { createFileRoute } from '@tanstack/react-router';
import ComingSoonCover from '@/components/ComingSoonCover';
export const Route = createFileRoute('/_staff/places/_layout/_placeholders/contract-and-cost')({
  component: () => <ComingSoonCover />
});